import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    Body, Heading, Title,
    Card as StyledCard
} from './styles';

const Card = ({ children, className, ...rest }) => {
    const classes = classNames('card', className);
    return (
        <StyledCard className={classes} {...rest}>
            {children}
        </StyledCard>
    );
};

Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

Card.Heading = function CardHeading({ children, className, ...rest }) {
    const classes = classNames('card-header', className);
    return (
        <Heading className={classes} {...rest}>
            {children}
        </Heading>
    );
};

Card.Heading.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

Card.Title = function CardTitle({ children, className, ...rest }) {
    const classes = classNames('card-title', className);
    return (
        <Title className={classes} {...rest}>
            {children}
        </Title>
    );
};

Card.Title.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

Card.Body = function CardBody({ children, className, ...rest }) {
    const classes = classNames('card-body', className);
    return (
        <Body className={classes} {...rest}>
            {children}
        </Body>
    );
};

Card.Body.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default Card;
